import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  message,
  Modal,
  Pagination,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import { PermissionDirect } from "../../Components/PermissionDirect";
import styles from "./Orders.module.scss";
import { TabsProps } from "antd/lib";
import {
  BusinessPlanApi,
  CommonApi,
  FreightRevenueApi,
  OrderApi,
  ReportsApi,
  RouteManagerApi,
} from "../../services";
import { checkPermissions } from "../../utils/checkPermissions";
import { useHistory, useLocation } from "react-router";
import { useRecoilValue } from "recoil";
import { UserAtom } from "../../store";
import {
  buildColumnsWithHeaderFilters,
  HeaderTable,
  TableActionButtons,
  Tabs,
} from "../../Components";
import { decorateEditableColumns } from "../../shared/helpers/editableColumns";
import { updateColumnDisplayState } from "../../shared/helpers/tableColumns";
import { useRequestLock } from "../../shared/hooks/useRequestLock";
import { PlusIcon, Setting } from "../../assets/icon";
import dayjs, { type Dayjs } from "dayjs";
import { useCallback, useEffect, useRef, useState } from "react";
import { unstable_batchedUpdates } from "react-dom";
import { TruckVendorApi } from "../../services";
import { buildOrderColumns } from "./columns";
import { OrderCostDetailTable } from "./OrderCostDetailTable";
import {
  buildBusinessPlanLookupOption,
  buildCustomerLookupOption,
  buildLookupRequestParams,
  buildRouteBaseLookupOption,
  buildTruckVendorLookupOption,
  type LookupFilters,
} from "../../shared/lookupTables";
import {
  acquireOrderSaveLock,
  buildLicensePlateOptions,
  buildOrderRoutePayload,
  buildOrderCostReviewPayload,
  canExportOrderTab,
  canSaveOrderRow,
  formatAmount,
  getAllowedOrderCostReviewStatuses,
  getAllowedOrderTab,
  getOrderFeatureByTab,
  getOrderPaginationAfterDelete,
  getOrderRoutePreviewMeta,
  getSafeOrderTab,
  hasNullRequiredField,
  isOrderCostReviewPayloadAllowed,
  isCurrentOrderDetailRequest,
  isDraftOrderRecord,
  mapAllEditableNodesToPayload,
  normalizeCombinedRateForPayload,
  normalizeDetailFieldValue,
  normalizeTouchedKey,
  resetOrderPaginationToFirstPage,
  releaseOrderSaveLock,
  setByPath,
  setDeepImmutable,
  shouldAdvanceOrderCostReview,
  shouldFetchOrderList,
  shouldResetOrderTruckVendorOnFieldChange,
  toPath,
  updateTreeById,
  type OrderDetailRequestIdentity,
} from "./helpers";
import {
  REQUIRED_FIELDS,
  REQUIRED_FINISH,
  orderStatusByTab,
} from "./constants";
import {
  emitOrderCrossTabEvent,
  shouldReloadOrderTabFromEvent,
  subscribeOrderCrossTabEvents,
} from "./orderCrossTabEvents";
import type {
  OrderCostDetail,
  OrderCostDetailState,
  OrderCostReviewer,
  TruckVendorOption,
} from "./types";
import {
  CheckCircleOutlined,
  DeleteOutlined,
  EditFilled,
  FormOutlined,
} from "@ant-design/icons";
import {
  getTruckVendorSearchOwnershipByOwnership,
  getTruckVendorTypeByOwnership,
} from "../../shared/helpers/truckVendorOwnership";

import { getPermissionRegions } from "../../services";
import { getPermissionDirections } from "../../services/domains/permission";

const { RangePicker } = DatePicker;
type ReportQuickRangeValue = [Dayjs, Dayjs];
type ReportQuickRange = {
  label: string;
  value: string;
  getRange: () => ReportQuickRangeValue;
};
const getQuarterRange = (offset = 0): ReportQuickRangeValue => {
  const base = dayjs().add(offset * 3, "month");
  const quarterStartMonth = Math.floor(base.month() / 3) * 3;
  const quarterStart = base.month(quarterStartMonth).startOf("month");

  return [quarterStart, quarterStart.add(2, "month").endOf("month")];
};
const reportQuickRanges: ReportQuickRange[] = [
  {
    label: "Tháng này",
    value: "thisMonth",
    getRange: (): ReportQuickRangeValue => [
      dayjs().startOf("month"),
      dayjs().endOf("month"),
    ],
  },
  {
    label: "Tháng trước",
    value: "lastMonth",
    getRange: (): ReportQuickRangeValue => [
      dayjs().subtract(1, "month").startOf("month"),
      dayjs().subtract(1, "month").endOf("month"),
    ],
  },
  {
    label: "Quý này",
    value: "thisQuarter",
    getRange: () => getQuarterRange(),
  },
  {
    label: "Quý trước",
    value: "lastQuarter",
    getRange: () => getQuarterRange(-1),
  },
];
const apiDebounceCustomer = (search: string) => {
  return FreightRevenueApi.getAllCustomer({ searchText: search }).then(
    (res: any) => res.data?.map(buildCustomerLookupOption),
  );
};
const apiDebouncePAKD = (
  search: string,
  customerId: string,
  filters: LookupFilters = {},
) => {
  return BusinessPlanApi.getAllBussinessPlan(
    {
      ...buildLookupRequestParams(search, filters, ["validFrom"]),
      state: "ACTIVE",
      customer: customerId,
    },
    { silentLoading: true },
  ).then((res: any) => res.data?.map(buildBusinessPlanLookupOption));
};
const apiDebounceRoute = (
  search: string,
  _value?: string,
  filters: LookupFilters = {},
) => {
  return RouteManagerApi.getAllRouterBase(buildLookupRequestParams(search, filters), {
    silentLoading: true,
  }).then((res: any) => res.data?.map(buildRouteBaseLookupOption));
};
// const apiDebounceRegion = (search: string) => {

//   // return CommonApi.getSearchRegion({ searchText: search }).then(
//   //   (res: any) => res.data || [],
//   // );
// };

const { confirm } = Modal;
const Orders = () => {
  // Define constant
  const [onModalPostion, setOnModalPosition] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState<any>({});
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [ordersReloadKey, setOrdersReloadKey] = useState(0);
  const orderSaveLocksRef = useRef(new Set<string>());
  const { isLocked, runLocked } = useRequestLock();
  const [savingOrderRows, setSavingOrderRows] = useState<
    Record<string, boolean>
  >({});
  const handleOrderFiltersChange = useCallback((nextFilters: any) => {
    unstable_batchedUpdates(() => {
      setPagination((prev) => resetOrderPaginationToFirstPage(prev));
      setFilters(nextFilters);
    });
  }, []);
  // const [increLoading, setIncreLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const tabs = query.get("tabs");
  const permissionState = useRecoilValue<any>(UserAtom.permissions);
  const features = permissionState?.features;
  const canViewOrderCostSheet = checkPermissions(
    "ORDER_COST_SHEET",
    "view",
    features,
  );
  const featuresRef = useRef(features);
  const canViewOrderCostSheetRef = useRef(canViewOrderCostSheet);
  featuresRef.current = features;
  canViewOrderCostSheetRef.current = canViewOrderCostSheet;
  const [messageApi, contextHolder] = message.useMessage();
  const [reportForm] = Form.useForm();
  const [editIndex, setEditIndex] = useState<any>([]);
  const [dataDetail, setDataDetail] = useState<OrderCostDetail | null>(null);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const isSavingDetail = () =>
    Boolean(
      dataDetail?._id &&
        isLocked(`order-cost-sheet:save:${dataDetail._id}`),
    );
  const savingDetail = isSavingDetail();
  const [allocatingCost, setAllocatingCost] = useState(false);
  const [exportReportModalOpen, setExportReportModalOpen] = useState(false);
  const [exportReportLoading, setExportReportLoading] = useState(false);
  const [
    truckVendorVehicleOptionsByVendorId,
    setTruckVendorVehicleOptionsByVendorId,
  ] = useState<Record<string, { label: string; value: string }[]>>({});
  const [licensePlateOptionsByRow, setLicensePlateOptionsByRow] = useState<
    Record<string, { label: string; value: string }[]>
  >({});

  const [permissionRegions, setPermissionRegions] = useState<
    { label: string; value: string }[]
  >([]);
  const [permissionDirections, setPermissionDirections] = useState<
    { label: string; value: string }[]
  >([]);

  const getSelectValue = (value: any) => {
    if (!value) return undefined;
    if (typeof value === "string") return value;
    return value?.value || value?._id;
  };

  const getExistingTruckVendorVehicleOptions = (record: any) =>
    buildLicensePlateOptions(
      record?.truckVendor?.vehicleList ||
        record?.truckVendorName?.vehicleList ||
        record?.vehicleList,
    );
  const apiDebounceTruckVendor = useCallback(
    (
      search: string,
      truckVendorType: "OWNER" | "CONTRACTOR" | "",
      ownershipFilter = "",
      filters: LookupFilters = {},
    ) => {
      return TruckVendorApi.getAllTruckVendorSearch({
        ...buildLookupRequestParams(search, filters),
        truckVendorType: truckVendorType,
        ownership: ownershipFilter || undefined,
      }).then((res: any) => {
        const listData = res?.data || [];
        const vendorVehicleMap = listData.reduce(
          (
            acc: Record<string, { label: string; value: string }[]>,
            item: any,
          ) => {
            acc[item._id] = buildLicensePlateOptions(item.vehicleList);
            return acc;
          },
          {},
        );

        setTruckVendorVehicleOptionsByVendorId((prev) => ({
          ...prev,
          ...vendorVehicleMap,
        }));

        return listData.map(buildTruckVendorLookupOption);
      });
    },
    [],
  );
  const apiDebounceOwnerTruckVendor = useCallback(
    (
      search: string,
      ownershipFilter = "",
      filters: LookupFilters = {},
    ) => apiDebounceTruckVendor(search, "OWNER", ownershipFilter, filters),
    [apiDebounceTruckVendor],
  );
  const apiDebounceOwnerInvestmentTruckVendor = useCallback(
    (search: string, _value?: string, filters: LookupFilters = {}) =>
      apiDebounceOwnerTruckVendor(search, "INVESTMENT", filters),
    [apiDebounceOwnerTruckVendor],
  );
  const apiDebounceOwnerDryRentalTruckVendor = useCallback(
    (search: string, _value?: string, filters: LookupFilters = {}) =>
      apiDebounceOwnerTruckVendor(search, "DRY_RENTAL", filters),
    [apiDebounceOwnerTruckVendor],
  );
  const apiDebounceOwnerAllTruckVendor = useCallback(
    (search: string, _value?: string, filters: LookupFilters = {}) =>
      apiDebounceOwnerTruckVendor(search, "", filters),
    [apiDebounceOwnerTruckVendor],
  );
  const apiDebounceContractorTruckVendor = useCallback(
    (search: string, _value?: string, filters: LookupFilters = {}) =>
      apiDebounceTruckVendor(search, "CONTRACTOR", "", filters),
    [apiDebounceTruckVendor],
  );
  const apiDebounceAllTruckVendor = useCallback(
    (search: string, _value?: string, filters: LookupFilters = {}) =>
      apiDebounceTruckVendor(search, "", "", filters),
    [apiDebounceTruckVendor],
  );
  const getBusinessPlanTruckVendorFetchOptions = useCallback(
    (record: any) => {
      const truckVendorType = getTruckVendorTypeByOwnership(record.ownership);
      const ownershipFilter = getTruckVendorSearchOwnershipByOwnership(
        record.ownership,
      );

      if (!truckVendorType) return apiDebounceAllTruckVendor;

      if (truckVendorType === "OWNER") {
        if (ownershipFilter === "INVESTMENT") {
          return apiDebounceOwnerInvestmentTruckVendor;
        }

        if (ownershipFilter === "DRY_RENTAL") {
          return apiDebounceOwnerDryRentalTruckVendor;
        }

        return apiDebounceOwnerAllTruckVendor;
      }

      return apiDebounceContractorTruckVendor;
    },
    [
      apiDebounceAllTruckVendor,
      apiDebounceContractorTruckVendor,
      apiDebounceOwnerDryRentalTruckVendor,
      apiDebounceOwnerAllTruckVendor,
      apiDebounceOwnerInvestmentTruckVendor,
    ],
  );

  const options = {
    ORDER_V2_STATUS: [
      { label: "Chờ duyệt", value: "PENDING_APPROVAL", color: "#0082FB" },
      { label: "Đang vận chuyển", value: "SHIPPING", color: "#FF6200" },
      { label: "Đã kết thúc", value: "FINISHED", color: "#00B517" },
      { label: "Đã hủy", value: "CANCELLED", color: "#FF0000" },
    ],
    ORDER_V2_COST_STATUS: [
      { label: "Khởi tạo", value: "INIT", color: "#0082FB" },
      {
        label: "Chờ duyệt cấp 1",
        value: "WAITING_APPROVE_L1",
        color: "#FF6200",
      },
      {
        label: "Chờ duyệt cấp 2",
        value: "WAITING_APPROVE_L2",
        color: "#FF6200",
      },
      { label: "Đã duyệt", value: "APPROVED", color: "#00B517" },
      { label: "Đã đóng", value: "CLOSED", color: "#FF0000" },
    ],
    ORDER_TRANSPORT_TYPE: [
      { label: "Nhập", value: "IMPORT" },
      { label: "Xuất", value: "EXPORT" },
      { label: "Bắc - Nam", value: "ROAD" },
      { label: "Chuyển kho", value: "TRANSFER" },
    ],
    // ORDER_COST_LINE_REVIEW: {
    //   PENDING: "PENDING",
    //   APPROVED: "APPROVED",
    //   REQUEST_EDIT: "REQUEST_EDIT",
    //   REJECTED: "REJECTED",
    // },
    ORDER_CONT_TYPE: [20, 40, 45, 48],
    ORDER_DELIVERY_METHOD: [
      { label: "Nguyên seal", value: "FULL_SEAL" },
      { label: "Kiểm đếm", value: "TALLY" },
    ],
    ORDER_OWNERSHIP: [
      { label: "ĐẦU TƯ", value: "INVESTMENT" },
      { label: "THUÊ KHÔ", value: "DRY_RENTAL" },
      { label: "DỊCH VỤ", value: "SERVICE" },
    ],
    ORDER_COMBINED_RATE_STATUS: [
      1,
      0.9,
      0.85,
      0.8,
      0.75,
      0.7,
      0.65,
      0.6,
      0.55,
      0.5,
      0.45,
      "CY",
    ],
  };
  const newObj = {
    _id: null,
    truckVendor: null,
    truckVendorName: null,
    licensePlate: null,
    customerName: null,
    loadingDate: new Date(),
    returnDate: new Date(),
    transportType: null,
    productName: null,
    containerType: null,
    weight: null,
    deliveryMethod: null,
    businessPlanCode: null,
    routeCode: null,
    loadingDetail: null,
    returnDetail: null,
    estimatedRevenue: null,
    state: "new",
    status: null,
  };
  const tabItems: TabsProps["items"] = [
    {
      key: "1",
      label: "Tạo đơn",
      disabled: !checkPermissions("ORDER_CREATION", "view", features),
    },
    {
      key: "2",
      label: "Điều xe",
      disabled: !checkPermissions("ORDER_DISPATCHING", "view", features),
    },
    {
      key: "3",
      label: "Lịch sử đơn hàng",
      disabled: !checkPermissions("ORDER_HISTORY", "view", features),
    },
    // {
    //   key: "4",
    //   label: "Đã huỷ",
    //   disabled: !checkPermissions("ORDER", "view", features),
    // },
  ];
  const [dataSource, setDataSource] = useState<any>([]);
  const [activeTab, setActiveTab] = useState(getSafeOrderTab(tabs));
  const detailRequestIdentityRef = useRef<OrderDetailRequestIdentity>({
    id: 0,
    tab: activeTab,
  });
  const activeCostDetailIdRef = useRef<string | null>(null);
  const activeOrderFeature = getOrderFeatureByTab(activeTab);
  const handleOrderTabChange = useCallback((tab: string) => {
    const nextTab = getAllowedOrderTab(tab, features);
    if (!nextTab) return;

    detailRequestIdentityRef.current = {
      id: detailRequestIdentityRef.current.id + 1,
      tab: nextTab,
    };
    activeCostDetailIdRef.current = null;
    setLoadingDetail(false);
    setDataSource([]);
    setEditIndex([]);
    setDataDetail(null);
    setPagination((prev) => resetOrderPaginationToFirstPage(prev));
    setActiveTab(nextTab);
  }, [features]);

  const columns = (activeTabs: string): any[] =>
    buildOrderColumns({
      activeTab: activeTabs,
      options,
      permissionRegions,
      permissionDirections,
      apiDebounceCustomer,
      apiDebouncePAKD,
      apiDebounceRoute,
      apiDebounceTruckVendor,
    });

  // Function to handle action
  const handleActionTable = (action: string, record: any, index: string) => {
    const actionFeature = activeOrderFeature;
    const permissionAction = action === "delete" ? "delete" : "edit";
    if (
      !checkPermissions(
        actionFeature,
        permissionAction,
        featuresRef.current,
      )
    ) {
      return;
    }

    switch (action) {
      // case "detail":
      //   handleOnEditDetail(record._id, record?.detailState || record?.state);
      //   break;
      case "finish":
        confirm({
          title: "Xác nhận đơn đã hoàn thành",
          content: "Bạn có chắc chắn muốn xác nhận đơn đã hoàn thành không?",
          okText: "Xác nhận",
          cancelText: "Huỷ",
          onOk: async () => {
            if (
              !checkPermissions(
                actionFeature,
                "edit",
                featuresRef.current,
              )
            ) {
              return;
            }

            let required = true;
            REQUIRED_FINISH.map((item) => {
              if (!record[item.value]) {
                required = false;
                message.error(`Không được để trống ${item.label}`);
              }
            });
            required &&
              OrderApi.putUpdateOrderStatus(index, { status: "FINISHED" })
                .then(() => {
                  setDataSource((prev: any) =>
                    prev.filter((item: any) => item._id !== record._id),
                  );
                  setEditIndex((prev: any[]) =>
                    prev.filter((item) => item.index !== index),
                  );
                  emitOrderCrossTabEvent({
                    action: "finish",
                    orderId: index,
                    nextStatus: "FINISHED",
                  });
                })
                .catch((error) => {
                  messageApi.error(
                    error?.message ||
                      "Xác nhận hoàn thành đơn thất bại, vui lòng thử lại",
                  );
                });
          },
          onCancel() {},
        });
        break;
      case "requestEdit":
        confirm({
          title: "Xác nhận yêu cầu sửa lại",
          content: "Bạn có chắc chắn muốn yêu cầu sửa lại bản ghi này không?",
          okText: "Xác nhận",
          cancelText: "Huỷ",
          okType: "danger",
          onOk() {
            if (
              !checkPermissions(
                actionFeature,
                "edit",
                featuresRef.current,
              )
            ) {
              return;
            }

            OrderApi.putRejectOrderShipping(index)
              .then(() => {
                setDataSource((prev: any) =>
                  prev.filter((item: any) => item._id !== record._id),
                );
                setEditIndex((prev: any[]) =>
                  prev.filter((item) => item.index !== index),
                );
                setPagination((prev) => getOrderPaginationAfterDelete(prev));
                setOrdersReloadKey((prev) => prev + 1);
                emitOrderCrossTabEvent({
                  action: "requestEdit",
                  orderId: index,
                  nextStatus: "PENDING_APPROVAL",
                });
              })
              .catch((error) => {
                messageApi.error(
                  error?.message ||
                    "Yêu cầu chỉnh sửa thất bại, vui lòng thử lại",
                );
              });
          },
          onCancel() {},
        });
        break;
      case "edit":
        setLicensePlateOptionsByRow((prev) => ({
          ...prev,
          [String(index)]:
            prev[String(index)] || getExistingTruckVendorVehicleOptions(record),
        }));
        setEditIndex([...editIndex, { index: index, record: { ...record } }]);
        break;
      case "delete":
        confirm({
          title: "Xác nhận xoá",
          content: "Bạn có chắc chắn muốn xoá bản ghi này không?",
          okText: "Xoá",
          cancelText: "Huỷ",
          okType: "danger",
          onOk() {
            if (
              !checkPermissions(
                actionFeature,
                "delete",
                featuresRef.current,
              )
            ) {
              return;
            }

            OrderApi.deleteOrder(index)
              .then(() => {
                setDataSource((prev: any) =>
                  prev.filter((item: any) => item._id !== record._id),
                );
                setEditIndex((prev: any[]) =>
                  prev.filter((item) => item.index !== index),
                );
                setPagination((prev) => getOrderPaginationAfterDelete(prev));
                setOrdersReloadKey((prev) => prev + 1);
                emitOrderCrossTabEvent({
                  action: "delete",
                  orderId: index,
                  nextStatus: record.status,
                });
              })
              .catch((error) => {
                messageApi.error(
                  error?.message || "Xoá bản ghi thất bại, vui lòng thử lại",
                );
              });
          },
          onCancel() {},
        });
        // tìm index trong data theo id
        break;
      default:
        break;
    }
    // setEditIndex([...editIndex, { index: index, record: record }]);
  };
  const handleActionSave = async (index: any, key: number) => {
    const editItem = editIndex.find((ind: any) => ind.index === index);
    const rowEdit = editItem?.record;
    if (!rowEdit) {
      messageApi.error("Không tìm thấy dữ liệu cần lưu");
      return;
    }

    const isNew = rowEdit.state === "new";
    if (!canSaveOrderRow(isNew, activeTab, features)) return;
    if (!acquireOrderSaveLock(orderSaveLocksRef.current, index)) return;

    const saveKey = String(index);
    setSavingOrderRows((prev) => ({ ...prev, [saveKey]: true }));
    try {
      const newData: any = [...dataSource];
      const touchedFields = editItem?.touchedFields ?? {};
      // ✅ check NULL các field req
      if (hasNullRequiredField(rowEdit, REQUIRED_FIELDS)) {
        messageApi.error("Không được bỏ trống bất kỳ trường bắt buộc nào");
        return;
      }
      // payload đúng shape API
      const payload = {
        customer: rowEdit.customerName?.value || rowEdit.customer._id,
        loadingDate: rowEdit.loadingDate,
        returnDate: rowEdit.returnDate,
        transportType: rowEdit.transportType?.value || rowEdit.transportType,
        productName: rowEdit.productName,
        containerType: rowEdit.containerType?.value || rowEdit.containerType,
        weight: rowEdit.weight,
        deliveryMethod: rowEdit.deliveryMethod?.value || rowEdit.deliveryMethod,
        ...buildOrderRoutePayload(rowEdit, touchedFields),
        loadingDetail: rowEdit.loadingDetail,
        returnDetail: rowEdit.returnDetail,
        containerNumber: rowEdit.containerNumber,
        combinedRevenueRate: normalizeCombinedRateForPayload(
          rowEdit.combinedRevenueRate,
          touchedFields.combinedRevenueRate,
        ),
        combinedCostRate: normalizeCombinedRateForPayload(
          rowEdit.combinedCostRate,
          touchedFields.combinedCostRate,
        ),
      };

      const payloadV2 = {
        ...payload,
        truckVendor: rowEdit.truckVendorName
          ? rowEdit.truckVendorName?.value || rowEdit?.truckVendor?._id
          : null,
        licensePlate: rowEdit.licensePlate,
      };
      // // ===== CALL API =====
      if (isNew) {
        const res = await OrderApi.postAddOrder(payload);
        // ===== CHỈ KHI API OK =====
        if (res) {
          delete rowEdit.state;
          rowEdit._id = res?.data?._id;
          rowEdit.routeBase = newData[key].routeBase;
          setEditIndex((prev: any[]) =>
            prev.filter((ind: any) => ind.index !== index),
          );
          setDataSource((prev: any[]) =>
            prev.filter((item: any) => item._id !== index),
          );
          emitOrderCrossTabEvent({
            action: "create",
            orderId: rowEdit._id,
            nextStatus: res?.data?.status ?? "SHIPPING",
          });
        }
      } else {
        const resUpdate = await OrderApi.putUpdateOrder(
          index,
          activeTab !== "1" ? payloadV2 : payload,
        );
        rowEdit.status === "PENDING_APPROVAL" &&
          (await OrderApi.putUpdateOrderStatus(index, {
            status: "SHIPPING",
          }));
        // ===== CHỈ KHI API OK =====
        if (resUpdate) {
          delete rowEdit.state;
          rowEdit._id = resUpdate?.data?._id;
          rowEdit.routeBase = newData[key].routeBase;
          setEditIndex((prev: any[]) =>
            prev.filter((ind: any) => ind.index !== index),
          );
          if (rowEdit.status === "PENDING_APPROVAL") {
            setDataSource((prev: any[]) =>
              prev.filter((ind: any) => ind._id !== index),
            );
            emitOrderCrossTabEvent({
              action: "update",
              orderId: index,
              nextStatus: "SHIPPING",
            });
          } else {
            setDataSource((prev: any[]) =>
              prev.map((item: any) => (item._id === index ? rowEdit : item)),
            );
          }
        }
      }
      // // ===== CHỈ KHI API OK =====
      // if (res) {
      //   newData[key] = rowEdit;
      //   setDataSource(newData);
      // }
    } catch (err: any) {
      messageApi.error(err?.message || "Lưu thất bại");
    } finally {
      releaseOrderSaveLock(orderSaveLocksRef.current, index);
      setSavingOrderRows((prev) => {
        const next = { ...prev };
        delete next[saveKey];
        return next;
      });
    }
  };
  const handleActionCancel = (index: string | number) => {
    if (orderSaveLocksRef.current.has(String(index))) return;

    const editItem = editIndex.find((ind: any) => ind.index === index);
    if (isDraftOrderRecord(editItem?.record)) {
      setDataSource((prev: any) => prev.filter((_: any) => _._id !== index));
    }
    const newEdit = editIndex.filter((ind: any) => ind.index !== index);
    setEditIndex(newEdit);
    setLicensePlateOptionsByRow((prev) => {
      const next = { ...prev };
      delete next[String(index)];
      return next;
    });
  };
  const handleAddRow = () => {
    if (!checkPermissions("ORDER_CREATION", "add", features)) return;

    const newObjCreate = {
      ...newObj,
      _id: `create-${Date.now()}`,
    };
    setDataSource([newObjCreate, ...dataSource]);
    setEditIndex([
      ...editIndex,
      { index: newObjCreate._id, record: newObjCreate },
    ]);
  };
  const handleUpdateRow = (
    key: string | string[],
    value: any,
    index: string,
  ) => {
    return setEditIndex((prev: any[]) =>
      updateEditNestedRow(prev, key, value, index, true),
    );
    // ✅ set nested field
    // ✅ đánh dấu touched
  };
  const updateEditNestedRow = (
    rows: any[],
    key: string | string[],
    value: any,
    index: string | number,
    useNestedPath = false,
  ) => {
    const next = [...rows];
    const findInd = next.findIndex((item: any) => item.index === index);
    if (findInd === -1) return rows;

    const row = { ...next[findInd] };
    const record = { ...(row.record || {}) };
    const touchedKey = normalizeTouchedKey(key);
    const flatKey = typeof key === "string" ? key : touchedKey;

    row.record = useNestedPath
      ? setDeepImmutable(record, toPath(key), value)
      : { ...record, [flatKey]: value };
    if (key === "businessPlanCode") {
      const selectedOwnership = value?.ownership ?? value?.raw?.ownership ?? null;
      row.record.ownership = selectedOwnership;
    }
    if (shouldResetOrderTruckVendorOnFieldChange(key)) {
      row.record.truckVendor = null;
      row.record.truckVendorName = null;
      row.record.licensePlate = null;
      setLicensePlateOptionsByRow((prev) => ({
        ...prev,
        [String(index)]: [],
      }));
    }
    if (key === "routeCode" || key === "businessPlanCode") {
      const routeMeta = getOrderRoutePreviewMeta(value);
      row.record.receiptAddress =
        routeMeta.receiptAddress ?? record.receiptAddress;
      row.record.deliveryAddress =
        routeMeta.deliveryAddress ?? record.deliveryAddress;
      row.record.direction = routeMeta.direction ?? record.direction;
    }
    row.touchedFields = { ...(row.touchedFields || {}), [touchedKey]: true };
    next[findInd] = row;

    return next;
  };

  const reloadOrderCostSheet = async (
    id: string,
    fallbackState?: OrderCostDetailState,
  ) => {
    if (!canViewOrderCostSheetRef.current) return;
    if (activeCostDetailIdRef.current !== id) return;
    if (detailRequestIdentityRef.current.tab !== activeTab) return;

    const requestIdentity: OrderDetailRequestIdentity = {
      id: detailRequestIdentityRef.current.id + 1,
      tab: activeTab,
    };
    detailRequestIdentityRef.current = requestIdentity;
    const isCurrentRequest = () =>
      canViewOrderCostSheetRef.current &&
      activeCostDetailIdRef.current === id &&
      isCurrentOrderDetailRequest(
        requestIdentity,
        detailRequestIdentityRef.current,
      );

    setLoadingDetail(true);
    try {
      const response = await OrderApi.getOrderCostSheet(id);
      if (!isCurrentRequest()) return;

      setDataSource((prev: any[]) =>
        prev.map((item: any) =>
          item._id === id
            ? { ...item, costStatus: response?.order?.costStatus }
            : item,
        ),
      );
      setDataDetail({
        _id: id,
        onEdit: false,
        ...(response.costSheet || {}),
        state: response?.order?.costStatus || fallbackState,
      });
    } catch (error: any) {
      if (!isCurrentRequest()) return;

      messageApi.error(error?.message || "Lấy chi tiết đơn hàng thất bại");
    } finally {
      if (isCurrentRequest()) setLoadingDetail(false);
    }
  };

  const handleOnEditDetail = async (
    id: string,
    state?: OrderCostDetailState,
  ) => {
    if (!canViewOrderCostSheetRef.current) return;
    if (isSavingDetail()) return;

    activeCostDetailIdRef.current = id;
    setDataDetail(null);
    await reloadOrderCostSheet(id, state);
  };

  const handleOnChangeDetail = (
    configId: string | number,
    dataIndex: string | (string | number)[],
    value: any,
  ) => {
    const path = Array.isArray(dataIndex) ? dataIndex : [dataIndex];
    const normalizedValue = normalizeDetailFieldValue(value);
    const touchedKey = path.join(".");
    const isReviewChange = path[0] === "reviews";

    if (!isReviewChange) {
      if (!checkPermissions("ORDER_COST_SHEET", "edit", features)) return;
    } else {
      const reviewer = path[1] as OrderCostReviewer;
      if (reviewer !== "sale" && reviewer !== "manager") return;
      const expectedState =
        reviewer === "sale"
          ? "WAITING_APPROVE_L1"
          : "WAITING_APPROVE_L2";
      const canApprove = checkPermissions(
        "INCURRED",
        reviewer === "sale" ? "approve" : "approve_l2",
        features,
      );
      const canReject = checkPermissions("INCURRED", "reject", features);

      if (dataDetail?.state !== expectedState) return;
      if (
        path[2] === "status" &&
        !getAllowedOrderCostReviewStatuses({
          canApprove,
          canReject,
        }).includes(normalizedValue)
      ) {
        return;
      }
      if (path[2] === "note" && !canReject) return;
      if (path[2] !== "status" && path[2] !== "note") return;
    }

    setDataDetail((prev) => {
      if (!prev) return prev;

      return {
        ...prev,
        onEdit: true,
        lines: updateTreeById(prev.lines ?? [], configId, (node) => {
          const nextNode = setByPath(node, path, normalizedValue);
          return {
            ...nextNode,
            touchedFields: {
              ...(nextNode.touchedFields || {}),
              [touchedKey]: true,
            },
          };
        }),
      };
    });
  };

  const handleSaveDetail = async () => {
    if (!checkPermissions("ORDER_COST_SHEET", "edit", features)) return;
    if (!dataDetail?._id) return;

    const payload = mapAllEditableNodesToPayload(dataDetail.lines ?? []);
    if (!payload.changes.length) {
      setDataDetail((prev) => (prev ? { ...prev, onEdit: false } : prev));
      return;
    }

    try {
      await runLocked(`order-cost-sheet:save:${dataDetail._id}`, async () => {
        await OrderApi.patchUpdateOrderCost(dataDetail._id, payload);
        await reloadOrderCostSheet(dataDetail._id, dataDetail.state);
      });
    } catch (error: any) {
      messageApi.error("Lưu thay đổi thất bại");
    }
  };

  const ensureDetailSavedBeforeSubmit = () => {
    if (!dataDetail?.onEdit) return true;
    messageApi.warning("Vui lòng lưu thay đổi trước khi chuyển duyệt");
    return false;
  };

  const handleSubmitOrderCostLevel1 = async () => {
    if (
      !checkPermissions(
        "ORDER_COST_SHEET",
        "edit",
        featuresRef.current,
      )
    ) {
      return;
    }
    if (!dataDetail?._id || !ensureDetailSavedBeforeSubmit()) return;

    const targetId = dataDetail._id;
    try {
      await OrderApi.putSubmitOrderCost(targetId, 1);
      await reloadOrderCostSheet(targetId, "WAITING_APPROVE_L1");
    } catch (error: any) {
      messageApi.error("Chuyển duyệt cấp 1 thất bại");
    }
  };

  const handleReviewOrderCost = async (
    level: 1 | 2,
    reviewer: OrderCostReviewer,
  ) => {
    if (!dataDetail?._id) return false;
    if (
      !checkPermissions(
        "ORDER_COST_SHEET",
        "view",
        featuresRef.current,
      )
    ) {
      return false;
    }
    if (
      (level === 1 && reviewer !== "sale") ||
      (level === 2 && reviewer !== "manager")
    ) {
      return false;
    }

    const payload = buildOrderCostReviewPayload(
      dataDetail.lines ?? [],
      reviewer,
    );
    if (!payload.items.length) {
      messageApi.warning("Chưa có dòng nào được chọn duyệt");
      return false;
    }

    const reviewPermissions = {
      canApprove: checkPermissions(
        "INCURRED",
        level === 1 ? "approve" : "approve_l2",
        featuresRef.current,
      ),
      canReject: checkPermissions(
        "INCURRED",
        "reject",
        featuresRef.current,
      ),
    };
    if (!isOrderCostReviewPayloadAllowed(payload, reviewPermissions)) {
      messageApi.warning(
        "Không có quyền thực hiện trạng thái duyệt đã chọn",
      );
      return false;
    }

    const targetId = dataDetail._id;
    const fallbackState = dataDetail.state;
    const shouldAdvance =
      level === 1 &&
      shouldAdvanceOrderCostReview(dataDetail.lines ?? [], reviewer);

    try {
      await OrderApi.patchReviewOrderCost(targetId, level, payload);
      let didAdvance = false;
      if (
        shouldAdvance &&
        checkPermissions(
          "INCURRED",
          "approve",
          featuresRef.current,
        )
      ) {
        await OrderApi.putSubmitOrderCost(targetId, 2);
        didAdvance = true;
      }
      await reloadOrderCostSheet(
        targetId,
        didAdvance ? "WAITING_APPROVE_L2" : fallbackState,
      );
      return true;
    } catch (error: any) {
      messageApi.error("Lưu duyệt thất bại");
      return false;
    }
  };

  const handleAllocateActualCost = async () => {
    if (!checkPermissions("ORDER_COST_SHEET", "edit", features)) return;

    try {
      setAllocatingCost(true);
      await OrderApi.postAllocateOrderCost({
        from: dayjs().startOf("month").toISOString(),
        to: dayjs().toISOString(),
      });

      if (dataDetail?._id) {
        await reloadOrderCostSheet(dataDetail._id, dataDetail.state);
      }
    } catch (error: any) {
      messageApi.error(error?.message || "Phân bổ chi phí thực tế thất bại");
    } finally {
      setAllocatingCost(false);
    }
  };

  const resetExportReportForm = () => {
    reportForm.resetFields();
    reportForm.setFieldsValue({
      dateRange: undefined,
      type: ["ACTUAL"],
    });
  };

  const handleOpenExportReportModal = () => {
    if (!canExportOrderTab(activeTab, features)) return;

    resetExportReportForm();
    setExportReportModalOpen(true);
  };

  const handleChooseQuickReportRange = (
    getRange: () => ReportQuickRangeValue,
  ) => {
    reportForm.setFieldsValue({
      dateRange: getRange(),
    });
  };

  const handleCloseExportReportModal = () => {
    setExportReportModalOpen(false);
    resetExportReportForm();
  };

  const handleExportOrderSummaryReport = async () => {
    if (!canExportOrderTab(activeTab, features)) return;

    try {
      const values = await reportForm.validateFields();
      const [fromDate, toDate] = values.dateRange || [];

      setExportReportLoading(true);
      await ReportsApi.exportOrderSummaryReport({
        from: dayjs(fromDate).startOf("day").toISOString(),
        to: dayjs(toDate).endOf("day").toISOString(),
        type: values.type,
      });
      handleCloseExportReportModal();
    } catch (error: any) {
      if (!error?.errorFields) {
        return;
      }
    } finally {
      setExportReportLoading(false);
    }
  };

  const handleOnChangePosition = (
    dataIndex: string,
    value: boolean | "left" | "right",
    type: "hidden" | "fixed",
  ) => {
    setActiveColumn(
      updateColumnDisplayState(activeColumns, dataIndex, value, type),
    );
  };
  const [activeColumns, setActiveColumn] = useState(columns(activeTab) ?? []);
  const resolvedOrderColumns = activeColumns.map((col: any) => {
    if (col.dataIndex === "truckVendorName") {
      return {
        ...col,
        editProps: (cellValue: any, record: any, editRows: any[]) => {
          const editingRecord =
            editRows?.find((ind: any) => ind.index === record._id)?.record ||
            {};
          const lookupRecord = { ...record, ...editingRecord };

          return {
          placeholder: "Chọn nhà xe",
          showSearch: true,
          allowClear: true,
          ...(typeof col.editProps === "function"
            ? col.editProps(cellValue, record, editRows)
            : col.editProps),
          fetchOptions: getBusinessPlanTruckVendorFetchOptions(lookupRecord),
          onChange: (selectedTruckVendor: TruckVendorOption | null) => {
            if (!record?._id) return;
            const vendorId = getSelectValue(selectedTruckVendor);
            const vehicleOptions = vendorId
              ? truckVendorVehicleOptionsByVendorId[vendorId] || []
              : [];

            setLicensePlateOptionsByRow((prev) => ({
              ...prev,
              [String(record._id)]: vehicleOptions,
            }));

            setEditIndex((prev: any[]) => {
              let next = updateEditNestedRow(
                prev,
                "truckVendor",
                vendorId || null,
                record._id,
              );
              next = updateEditNestedRow(
                next,
                "licensePlate",
                null,
                record._id,
              );
              return next;
            });
          },
          value:
            record?._id && editRows
              ? editingRecord?.truckVendorName || cellValue
              : cellValue,
          };
        },
      };
    }

    if (col.dataIndex === "licensePlate") {
      return {
        ...col,
        editType: "SelectOption",
        editProps: (cellValue: any, record: any, editRows: any[]) => {
          const editingRecord =
            editRows?.find((ind: any) => ind.index === record._id)?.record ||
            {};
          const selectedTruckVendorId =
            getSelectValue(editingRecord?.truckVendor) ||
            getSelectValue(editingRecord?.truckVendorName);
          const rowLicensePlateOptions = record?._id
            ? licensePlateOptionsByRow[String(record._id)]
            : undefined;
          const cachedVendorOptions = selectedTruckVendorId
            ? truckVendorVehicleOptionsByVendorId[
                String(selectedTruckVendorId)
              ] || []
            : [];
          const fallbackOptions = getExistingTruckVendorVehicleOptions(
            editingRecord || record,
          );

          return {
            placeholder: "Chọn biển số xe",
            allowClear: true,
            showSearch: true,
            options: rowLicensePlateOptions?.length
              ? rowLicensePlateOptions
              : cachedVendorOptions.length
                ? cachedVendorOptions
                : fallbackOptions,
            disabled: !selectedTruckVendorId,
          };
        },
      };
    }

    return col;
  });

  // Function to render
  const columnsRender = buildColumnsWithHeaderFilters(
    [
      ...decorateEditableColumns(resolvedOrderColumns, {
        editIndex,
        getDataSource: () => dataSource,
        onUpdate: (dataIndex, value, rowId) =>
          handleUpdateRow(dataIndex, value, rowId),
      }),
      {
        title: "",
        key: "action",
        width: 60,
        fixed: "right",
        render: (_: any, record: any, index: number) => {
          const isSavingOrder = !!savingOrderRows[String(record._id)];

          return editIndex.find((ind: any) => ind.index === record._id) ? (
            <Row align={"middle"} justify={"center"}>
              <Button
                onClick={() => {
                  handleActionSave(record._id, index);
                }}
                loading={isSavingOrder}
                disabled={isSavingOrder}
                style={{ marginBottom: 5, width: "100%" }}
              >
                {record.status === "new" ? "Tạo đơn" : "Lưu"}
              </Button>{" "}
              <Button
                onClick={() => {
                  handleActionCancel(record._id);
                }}
                disabled={isSavingOrder}
                style={{ width: "100%" }}
              >
                Hủy
              </Button>
            </Row>
          ) : (
            <TableActionButtons
              items={[
                {
                  key: "requestEdit",
                  label: "Yêu cầu chỉnh sửa",
                  icon: <FormOutlined />,
                  tone: "info",
                  hidden: activeTab !== "2",
                  disabled: !checkPermissions(
                    activeOrderFeature,
                    "edit",
                    features,
                  ),
                  onClick: () =>
                    handleActionTable("requestEdit", record, record._id),
                },
                {
                  key: "edit",
                  label: "Chỉnh sửa",
                  icon: <EditFilled />,
                  tone: "edit",
                  disabled: !checkPermissions(
                    activeOrderFeature,
                    "edit",
                    features,
                  ),
                  onClick: () => handleActionTable("edit", record, record._id),
                },
                {
                  key: "delete",
                  label: "Xoá",
                  icon: <DeleteOutlined />,
                  tone: "delete",
                  danger: true,
                  hidden: !["1", "3"].includes(activeTab),
                  disabled: !checkPermissions(
                    activeOrderFeature,
                    "delete",
                    features,
                  ),
                  onClick: () =>
                    handleActionTable("delete", record, record._id),
                },
                {
                  key: "finish",
                  label: "Hoàn thành",
                  icon: <CheckCircleOutlined />,
                  tone: "download",
                  hidden: activeTab !== "2",
                  disabled: !checkPermissions(
                    activeOrderFeature,
                    "edit",
                    features,
                  ),
                  onClick: () =>
                    handleActionTable("finish", record, record._id),
                },
              ]}
            />
          );
        },
      },
    ],
    filters,
    handleOrderFiltersChange,
  );

  const renderModalPosition = () => {
    return (
      <Modal
        open={onModalPostion}
        className={styles.Modal}
        width={"70%"}
        onCancel={() => {
          setOnModalPosition(false);
        }}
        title="Hiển thị cột"
        bodyProps={{
          className: styles.ModalBody,
        }}
        footer={false}
      >
        <Row>
          <Col span={16}>Tên cột</Col>
          <Col span={4}>Hiển thị</Col>
          <Col span={4}>Cố định(trái, phải)</Col>
        </Row>
        <Divider />
        {activeColumns?.map((col: any, key: number) => {
          return (
            <div key={key}>
              <Row>
                <Col span={16}>{col.title}</Col>
                <Col span={4}>
                  <Checkbox
                    checked={!col.hidden}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked,
                        "hidden",
                      );
                    }}
                  />
                </Col>
                <Col span={4}>
                  <Checkbox
                    checked={col.fixed === "left" ? true : false}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked && "left",
                        "fixed",
                      );
                    }}
                    style={{ marginRight: "20px" }}
                  />
                  <Checkbox
                    checked={col.fixed === "right" ? true : false}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked && "right",
                        "fixed",
                      );
                    }}
                  />
                </Col>
              </Row>
              <Divider />
            </div>
          );
        })}
      </Modal>
    );
  };
  const renderExportReportModal = () => {
    return (
      <Modal
        open={exportReportModalOpen}
        title="Xuất báo cáo đơn hàng"
        okText="Xuất báo cáo"
        cancelText="Huỷ"
        onCancel={handleCloseExportReportModal}
        onOk={handleExportOrderSummaryReport}
        confirmLoading={exportReportLoading}
        destroyOnClose
      >
        <Form
          form={reportForm}
          layout="vertical"
          initialValues={{ type: ["ACTUAL"] }}
        >
          <Form.Item label="Chọn nhanh">
            <Space wrap>
              {reportQuickRanges.map((item) => (
                <Button
                  key={item.value}
                  onClick={() => handleChooseQuickReportRange(item.getRange)}
                >
                  {item.label}
                </Button>
              ))}
            </Space>
          </Form.Item>
          <Form.Item
            label="Khoảng thời gian"
            name="dateRange"
            rules={[
              {
                required: true,
                message: "Vui lòng chọn khoảng thời gian",
              },
            ]}
          >
            <RangePicker
              style={{ width: "100%" }}
              format="DD/MM/YYYY"
              allowClear
            />
          </Form.Item>
          <Form.Item
            label="Loại dữ liệu"
            name="type"
            rules={[
              {
                validator: (_, value) =>
                  Array.isArray(value) && value.length > 0
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error("Vui lòng chọn ít nhất một loại dữ liệu"),
                      ),
              },
            ]}
          >
            <Select
              mode="multiple"
              showSearch={false}
              allowClear
              maxTagCount="responsive"
              placeholder="Chọn loại dữ liệu"
              options={[
                { label: "Kế hoạch", value: "ESTIMATED" },
                { label: "Thực tế", value: "ACTUAL" },
              ]}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  };
  //Function to effect
  useEffect(() => {
    const nextTab = getAllowedOrderTab(tabs, features);
    if (!nextTab) return;

    if (activeTab !== nextTab) {
      handleOrderTabChange(nextTab);
    }

    if (tabs !== nextTab) {
      history.replace(`/operation/orders?tabs=${nextTab}`);
    }
  }, [activeTab, features, handleOrderTabChange, history, tabs]);

  useEffect(() => {
    if (canViewOrderCostSheet) return;

    activeCostDetailIdRef.current = null;
    detailRequestIdentityRef.current = {
      id: detailRequestIdentityRef.current.id + 1,
      tab: activeTab,
    };
    setLoadingDetail(false);
    setDataDetail(null);
  }, [activeTab, canViewOrderCostSheet]);

  useEffect(() => {
    activeCostDetailIdRef.current = null;
    detailRequestIdentityRef.current = {
      id: detailRequestIdentityRef.current.id + 1,
      tab: activeTab,
    };
    setLoadingDetail(false);
    setDataDetail(null);
    setActiveColumn(columns(activeTab));
  }, [activeTab, permissionRegions, permissionDirections]);

  useEffect(() => {
    return subscribeOrderCrossTabEvents((event) => {
      if (!shouldReloadOrderTabFromEvent(activeTab, event)) return;

      activeCostDetailIdRef.current = null;
      detailRequestIdentityRef.current = {
        id: detailRequestIdentityRef.current.id + 1,
        tab: activeTab,
      };
      setLoadingDetail(false);
      setDataDetail(null);
      setEditIndex([]);
      setPagination((prev) => resetOrderPaginationToFirstPage(prev));
      setOrdersReloadKey((prev) => prev + 1);
    });
  }, [activeTab]);

  useEffect(() => {
    if (!shouldFetchOrderList(activeTab, tabs, features)) return;

    let mounted = true;
    const fetchData = async () => {
      setLoading(true);
      const resDataOrders: any = await OrderApi.getAllOrder({
        current: pagination.current,
        pageSize: pagination.pageSize,
        status: orderStatusByTab[activeTab],
        ...filters,
        loadingDate: undefined,
        returnDate: undefined,
        loadingDateFrom: filters.loadingDate
          ? dayjs(filters.loadingDate[0]).startOf("day").toISOString()
          : undefined,
        loadingDateTo: filters.loadingDate
          ? dayjs(filters.loadingDate[1]).endOf("day").toISOString()
          : undefined,
        returnDateFrom: filters.returnDate
          ? dayjs(filters.returnDate[0]).startOf("day").toISOString()
          : undefined,
        returnDateTo: filters.returnDate
          ? dayjs(filters.returnDate[1]).endOf("day").toISOString()
          : undefined,
      });
      if (mounted) {
        setLoading(false);
        setDataSource(resDataOrders?.data ?? []);
        setPagination((prev) => ({
          ...prev,
          total: resDataOrders?.totalItem || 0,
        }));
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, [
    filters,
    pagination.current,
    pagination.pageSize,
    activeTab,
    features,
    ordersReloadKey,
    tabs,
  ]);

  useEffect(() => {
    let mounted = true;
    Promise.all([getPermissionRegions({}), getPermissionDirections({})]).then(
      ([regions, directions]: any) => {
        if (!mounted) return;

        setPermissionRegions(
          (regions ?? []).map((ite: any) => ({
            label: ite.name,
            value: ite._id,
          })),
        );
        setPermissionDirections(
          (directions ?? []).map((ite: any) => ({
            label: ite.name,
            value: ite.code,
          })),
        );
      },
    );
    return () => {
      mounted = false;
    };
  }, []);
  // Main render
  return (
    <PermissionDirect
      screen={["ORDER_CREATION", "ORDER_DISPATCHING", "ORDER_HISTORY"]}
    >
      <div className={styles.Orders}>
        {contextHolder}
        <div className="container">
          <HeaderTable
            title={"Đơn hàng"}
            buttons={[
              {
                children: "Cài đặt hiển thị",
                icon: <Setting />,
                onClick: () => {
                  setOnModalPosition(true);
                },
                type: "primary",
              },
              {
                children: "Xuất báo cáo",
                icon: <img src="/icon/xlsx.svg" />,
                onClick: handleOpenExportReportModal,
                type: "primary",
                disabled: !canExportOrderTab(activeTab, features),
              },
              {
                children: "Phân bổ chi phí thực tế",
                icon: <img src="/icon/xlsx.svg" />,
                onClick: handleAllocateActualCost,
                type: "primary",
                loading: allocatingCost,
                disabled: !checkPermissions(
                  "ORDER_COST_SHEET",
                  "edit",
                  features,
                ),
              },
              {
                children: "Import",
                icon: <img src="/icon/xlsx.svg" />,
                onClick: () => {
                  // setOpenModalImport(true);
                },
                style: {
                  backgroundColor: checkPermissions(
                    "ORDER_CREATION",
                    "import",
                    features,
                  )
                    ? "#00529F"
                    : "#C0C0C0",
                },
                disabled: !checkPermissions(
                  "ORDER_CREATION",
                  "import",
                  features,
                ),
              },
            ]}
          />
          <Tabs
            items={tabItems}
            activeKey={activeTab}
            onChange={(tab) => {
              const nextTab = getAllowedOrderTab(tab, features);
              if (!nextTab) return;

              handleOrderTabChange(nextTab);
              history.push(`/operation/orders?tabs=${nextTab}`);
            }}
          />
          <Table
            columns={columnsRender}
            size="small"
            dataSource={dataSource}
            scroll={{ x: "max-content" }}
            style={{ width: "100%" }} // Full theo container
            pagination={false}
            loading={loading}
            onRow={(record: any) =>
              activeTab === "1"
                ? {}
                : {
                    onDoubleClick: () => {
                      if (
                        checkPermissions(
                          "ORDER_COST_SHEET",
                          "view",
                          features,
                        )
                      ) {
                        handleOnEditDetail(
                          record._id,
                          record?.detailState || record?.state,
                        );
                      } else {
                        message.error(
                          "Bạn không có quyền xem chi phí phát sinh",
                        );
                      }
                    },
                  }
            }
            rowClassName={(record: any) =>
              dataDetail?._id && record._id === dataDetail?._id
                ? styles.HightLightRow
                : ""
            }
          />

          {activeTab === "1" && (
            <Button
              className={styles.ButtonPlus}
              icon={<PlusIcon />}
              onClick={handleAddRow}
              disabled={
                !checkPermissions("ORDER_CREATION", "add", features)
              }
            >
              Thêm mới
            </Button>
          )}
          <Pagination
            total={pagination.total}
            current={pagination.current}
            pageSize={pagination.pageSize}
            onChange={(page, pageSize) => {
              setPagination((prev) => ({
                ...prev,
                current: page,
                pageSize: pageSize || prev.pageSize,
              }));
            }}
            showSizeChanger
            pageSizeOptions={[5, 10, 20, 50, 100]}
            align="end"
            className={styles.Pagination}
          />
        </div>
        <OrderCostDetailTable
          dataDetail={dataDetail}
          loadingDetail={loadingDetail}
          savingDetail={savingDetail}
          features={features}
          footerButtonClassName={styles.ButtonFooterTableDetail}
          activeTab={activeTab}
          onClose={() => {
            if (isSavingDetail()) return;
            activeCostDetailIdRef.current = null;
            detailRequestIdentityRef.current = {
              id: detailRequestIdentityRef.current.id + 1,
              tab: activeTab,
            };
            setLoadingDetail(false);
            setDataDetail(null);
          }}
          onChangeDetail={handleOnChangeDetail}
          onSaveDetail={handleSaveDetail}
          onSubmitLevel1={handleSubmitOrderCostLevel1}
          onReview={handleReviewOrderCost}
        />
      </div>
      {renderModalPosition()}
      {renderExportReportModal()}
    </PermissionDirect>
  );
};
export { Orders };
